import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import IconDownload from '@assets/icon/download.svg';

import Icon from '@components/Icon';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Link from '@components/Link';
import Heading from '@components/Heading';

const FlexRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`
const IconMargin = css`
  margin-right: 24px;
  margin-top: 4px;
`

export interface PlanInformationProps {
  brochureUrl?: string;
}

function PlanInformation({ brochureUrl }: PlanInformationProps) {
  const theme: ITheme = useTheme();
  return (
    <ContainerBlock
      background={theme.colors.grey[200]}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      borderTop={`3px solid ${theme.colors.primary}`}
      padding="25px 20px"
      paddingTablet="25px 30px"
    >
      <Heading variant="smallTitle" fontWeight={600} color={theme.colors.grey[400]} margin="0 0 20px">DIRECT - Singlife Term Life</Heading>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>Up to S$400,000 lump-sum payout upon death, Terminal Illness or Total and Permanent Disability to help you or your loved ones tide through a difficult period</Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>
              Choice of coverage period to suit your needs: <br/>
              - 5 years renewable term; <br/>
              - 20 years; or  <br/>
              - up to 65 age next birthday
          </Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>Option to add on rider to get a lump-sum payout upon diagnosis of any of the 30 covered critical illnesses so you can focus on recovery</Text>
        </div>
      </FlexRow>
      <Link text="Download brochure" icon={IconDownload} slotIcon="start" download="Brochure" target="_blank" rel="noopener noreferrer" url={brochureUrl} />
    </ContainerBlock>
  );
};

export default PlanInformation;
